import React from 'react';
import { useSelector } from 'react-redux';
import TextConditionsArgentina from './TextConditionsArgentina';
import TextConditionsBrazil from './TextConditionsBrazil';
import TextConditionsMexico from './TextConditionsMexico';
import TextConditionsPeru from './TextConditionsPeru';

export default function TextConditions({ paisId }) {
  const paisIdNum = Number(paisId) || 1;
  const templateData = useSelector((state) => state.applicationState.templateData);
  const footer = templateData?.footer;
  const header = templateData?.header;
  const principalOffice = templateData?.principalOffice;

  const emailContacto = header?.emailContacto || principalOffice?.email;
  const company = header?.empresa;
  const webUrl = footer?.web;
  const razonSocial = footer?.razonSocial;
  const nombre = footer?.razonSocial || footer?.nombreContacto;
  const domicilio = principalOffice?.direccion;

  const getDetalleValor = (nombreEnlace) =>
    footer?.detalle?.find((d) => d.tipoEnlace?.nombre === nombreEnlace)?.valor;
  const arcoNombre =
    getDetalleValor('aviso-privacidad-arco-nombre') || principalOffice?.nombre;
  const arcoDomicilio =
    getDetalleValor('aviso-privacidad-arco-domicilio') || principalOffice?.direccion;
  const arcoEmail =
    getDetalleValor('aviso-privacidad-arco-email') || principalOffice?.email;
  const arcoTelefono =
    getDetalleValor('aviso-privacidad-arco-telefono') || principalOffice?.telefono;
  const fechaUltimaActualizacion = getDetalleValor('aviso-privacidad-fecha-actualizacion');

  return (
    <div>
      {paisIdNum === 1 && <TextConditionsArgentina />}
      {paisIdNum === 2 && (
        <TextConditionsPeru
          nombre={nombre}
          razonSocial={razonSocial}
          emailContacto={emailContacto}
        />
      )}
      {paisIdNum === 3 && <TextConditionsBrazil />}
      {paisIdNum === 4 && (
        <TextConditionsMexico
          emailContacto={emailContacto}
          company={company}
          webUrl={webUrl}
          razonSocial={razonSocial}
          domicilio={domicilio}
          arcoNombre={arcoNombre}
          arcoDomicilio={arcoDomicilio}
          arcoEmail={arcoEmail}
          arcoTelefono={arcoTelefono}
          fechaUltimaActualizacion={fechaUltimaActualizacion}
        />
      )}
    </div>
  );
}
